import { storage } from '@cko/dashboard-shared';

export const LAST_SEEN_TIMESTAMP = 'cko-dashboard-notifications-last-seen';

export const lastSeenStorage = {
  getTimestamp: () => {
    return storage.get<string>(LAST_SEEN_TIMESTAMP);
  },
  setTimestamp: (timestamp: string) => {
    storage.set<string>(LAST_SEEN_TIMESTAMP, timestamp);
  },
};
